<template lang="pug">
.right_box_main
  // 面包屑导航

  .card-box
    // 右边卡片
    .card-rb
      .card-4
        el-card(:body-style="{ padding: '16px' }")
          .fisthang
            el-form.demo-form-inline(
              :inline="true",
              :model="searchlist",
              size="mini"
            )
              el-form-item(label="路线名称:", style="margin: 0 10 0 0")
                el-input(
                  v-model="searchlist.name",
                  placeholder="请输入路线名称",
                  style="width: 200px"
                )
              el-form-item(label="所属区域:", style="margin: 0 10 0 0")
                el-cascader(
                  v-model="searchlist.orgId",
                  :options="orgList",
                  @change="handleChange",
                  :show-all-levels="false"
                )
              el-form-item
                el-button(type="primary", @click="searchlistdata") 查询
              el-form-item
                el-button(type="info", @click="searchlistReset") 重置
          .three
            el-button(
              type="primary",
              size="mini",
              @click="showDialogForm('', 'add')"
            ) 新增
          // 表格盒子
          .table_card
            el-table(
              :data="tableData",
              :header-cell-style="{ background: '#f8fafa' }",
              border="",
              align="center"
            )
              //
                <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                border align="center" @row-click="changeColor" :row-style="selectedHighlight" >
              // <el-table-column type="selection" align="center"></el-table-column>
              el-table-column(
                type="index",
                align="center",
                label="序号",
                width="50"
              )
              el-table-column(align="center", prop="id", label="路线编号")
              el-table-column(align="center", prop="name", label="路线名称")
              el-table-column(align="center", prop="content", label="路线内容")
              el-table-column(align="center", prop="orgIdCn", label="所属机构")
              el-table-column(align="center", prop="times", label="添加时间")
              el-table-column(align="center", label="操作", fixed="right")
                template(slot-scope="scope")
                  el-tooltip.item(
                    effect="light",
                    content="查看",
                    placement="top-start"
                  )
                    button.iconfont.icon-chakan.tabBtn(
                      @click="showDialogForm(scope.row.id, 'detail')"
                    )
                  el-tooltip.item(
                    v-if="orgLevel !== 4",
                    effect="light",
                    content="修改",
                    placement="top-start"
                  )
                    button.iconfont.icon-bianji3.tabBtn(
                      @click="showDialogForm(scope.row.id, 'edit')"
                    )
                  el-tooltip.item(
                    v-if="orgLevel !== 4",
                    effect="light",
                    content="删除",
                    placement="top-start"
                  )
                    button.iconfont.icon-icon7.tabBtn(
                      @click="showdeletepanduan(scope.row.id)"
                    )
            el-pagination(
              :page-size="pageConfig.pageSize",
              layout="total, prev, pager, next, jumper",
              @current-change="handleCurrentChange",
              :total="pageConfig.total"
            )
  // 弹出框
  el-dialog(
    :title="dialogTitle",
    :visible.sync="showadd",
    width="85%",
    :before-close="clearadddata"
  )
    el-form(
      ref="baseForm",
      :rules="rules",
      :model="baseForm",
      label-width="110px",
      size="mini"
    )
      el-form-item(label="路线名称：", prop="name")
        el-input(
          :disabled="editDisable",
          v-model="baseForm.name",
          placeholder="请输入任务名称",
          style="width: 50%"
        )
      el-form-item(label="路线内容：", prop="content")
        el-input(
          type="textarea",
          v-model="baseForm.content",
          style="width: 50%",
          :disabled="editDisable"
        )
      el-form-item(label="所属机构：", prop="orgId")
        el-cascader(
          v-model="baseForm.orgId",
          :options="orgList",
          @change="handleChange1",
          :show-all-levels="false",
          :disabled="editDisable"
        )
      el-form-item(label="选择任务", prop="")
        .check
          el-checkbox-group(
            @change="check",
            v-model="checkList",
            :disabled="editDisable"
          )
            el-checkbox(
              :label="item.id",
              v-for="item in jgList",
              :key="item.id"
            ) {{ item.name }}
      el-form-item(label="已选任务", prop="", v-model="checkList")
        .check
          p(v-for="item in haveList", :key="item.id") {{ item.name }} ：{{ item.place }}
      el-form-item(label="路线地图：", prop="addressDetail")
        #mapDome(
          style="width: 100%; height: 400px; margin-top: 10px",
          :disabled="editDisable"
        )
    .boontbtn
      el-button(
        v-if="showSaveBtn",
        type="primary",
        size="small",
        style="margin: 0 30px",
        @click="saveadddata"
      ) 保存
      el-button(type="info", size="small", @click="showadd = false") 关闭
</template>

<script>
import { post, get } from "@/api/requrestHttp.js"
import editor_option from "../../../utils/editorOption.js"
import request from "../../../utils/request.js"
import AMap from "AMap" // 引入高德地图
export default {
  data() {
    return {
      mapmarker: "",
      jwList: [],
      markerList: [],
      haveList: [],
      checkList: [],
      jgList: [],
      orgList: [],
      dialogTitle: "新增",
      // 新增弹出层
      flag: "add",
      showadd: false,
      editDisable: false,
      showSaveBtn: true,
      baseForm: {},
      props: {
        key: "id",
        label: "name:place",
      },
      rules: {
        policyConsultationType: [
          { required: true, message: "请选择咨询类别", trigger: "blur" },
        ],
        advisoryName: [
          { required: true, message: "请输入咨询标题", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入咨询内容", trigger: "blur" },
        ],
        releaseDate: [
          { required: true, message: "请选择发布时间", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择发布状态", trigger: "blur" },
        ],
      },
      // 查询
      searchlist: {},
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      },
      status: true,
      activityAddress: {},
      baseForm: {},
      option4: [],
      option5: [],
      option6: [],
      orgLevel: "",
    }
  },
  created() {
    post("/rbac/admin/org/info/OrgTreelist", { orgType: 1,isValid: 1, }).then((res) => {
      this.orgList = res.content
    })
  },
  methods: {
    getOrgLevel() {
      post("admin/user/info/getLoginUserInfo", {
        id: this.$store.state.id,
      }).then((res) => {
        if (res.code == 200) {
          // this.userName=res.content.user.name;
          this.orgLevel = res.content.user.orgLevel
        } else {
          this.$message.error(res.message)
        }
      })
    },
    async getTaskInform(val) {
      var _this = this
      let fc = async function (id) {
        let res = await post("/admin/task/info/getTask", { id })
        let obj = {}
        obj.id = res.content.id
        obj.name = res.content.name
        obj.place = res.content.place
        //已选任务
        _this.haveList.push(obj)
        //显示地图坐标
        let latitude = res.content.latitude
        let longitude = res.content.longitude
        return [longitude, latitude]
      }
      if (val) {
        //this.mapcontainer.remove(this.mapmarker);

        this.haveList = []
        this.markerList = []
        this.jwList = []
        this.jwList = await Promise.all(
          val.map(async (item) => {
            // 等待异步操作完成，返回执行结果
            return await fc(item)
          })
        )
        //console.log(this.jwList);
        //console.log(this.jwList.length);
        if (this.jwList.length >= 2) {
          var walking = new AMap.Walking({})
          //console.log(this.jwList);
          for (let i = 0; i < this.jwList.length; i++) {
            walking.search(
              _this.jwList[i],
              _this.jwList[i + 1],
              function (status, result) {
                // result即是对应的步行路线数据信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_WalkingResult
                if (status === "complete") {
                  if (result.routes && result.routes.length) {
                    var path = _this.parseRouteToPath(result.routes[0])
                    var startMarker = new AMap.Marker({
                      position: path[0],
                      //icon: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',
                      map: _this.mapcontainer,
                    })

                    var endMarker = new AMap.Marker({
                      position: path[path.length - 1],
                      //icon: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
                      map: _this.mapcontainer,
                    })

                    var routeLine = new AMap.Polyline({
                      path: path,
                      isOutline: true,
                      outlineColor: "#ffeeee",
                      borderWeight: 2,
                      strokeWeight: 5,
                      strokeColor: "#0091ff",
                      lineJoin: "round",
                    })

                    routeLine.setMap(_this.mapcontainer)
                    _this.mapcontainer.setFitView()
                    log.success("绘制步行路线完成")
                  }
                } else {
                  log.error("步行路线数据查询失败" + result)
                }
              }
            )
          }
        } else {
          this.mapmarker = new AMap.Marker({
            position: _this.jwList[0],
            map: _this.mapcontainer,
          })
          _this.mapcontainer.setFitView()
        }
      }
    },
    async check(val) {
      var _this = this
      this.baseForm.taskId = val.toString()
      this.mapcontainer.clearMap()
      this.getTaskInform(val)
    },

    parseRouteToPath(route) {
      var path = []

      for (var i = 0, l = route.steps.length; i < l; i++) {
        var step = route.steps[i]

        for (var j = 0, n = step.path.length; j < n; j++) {
          path.push(step.path[j])
        }
      }

      return path
    },
    handleChange(value) {
      if (value != null) {
        this.searchlist.orgId = value[value.length - 1]
      }
    },
    handleChange1(value) {
      if (value != null) {
        this.baseForm.orgId = value[value.length - 1]
        this.getjgList()
      }
    },
    //获取任务点
    async getjgList() {
      await post("/admin/task/info/findTaskList", {
        orgId: this.baseForm.orgId,
        pageNo: 1,
        pageSize: 99,
      }).then((res) => {
        //console.log(res);
        this.jgList = res.content.list
      })
    },
    //条件查询
    searchlistdata() {
      this.pageConfig = {
        pageSize: 10,
        pageNo: 1,
      }
      this.getPageDatas()
    },
    searchlistReset() {
      this.searchlist = {}
      this.pageConfig = {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      }
      this.getPageDatas()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getPageDatas()
    },
    //获取列表数据
    async getPageDatas() {
      var res = await request({
        url: "/admin/way/info/findWayList",
        method: "POST",
        data: {
          ...this.searchlist,
          ...this.pageConfig,
        },
      })
      if (res.code == 200) {
        this.pageConfig.total = res.content.count
        this.tableData = res.content.list
      } else {
        this.$message({
          message: "数据加载异常：",
          type: "error",
        })
      }
    },

    async showDialogForm(id, flag) {
      this.flag = flag

      if (id != "") {
        if (flag == "edit") {
          this.editDisable = false
          this.showSaveBtn = true
          this.dialogTitle = "编辑"
        } else if (flag == "detail") {
          this.editDisable = true
          this.showSaveBtn = false
          this.dialogTitle = "查看"
        }
        //获取编辑项的最新数据
        let data = {}
        data.id = id
        var res = await request({
          url: "/admin/way/info/getWayList",
          method: "POST",
          data: data,
        })
        if (res.code == 200) {
          this.baseForm = res.content
          this.baseForm.orgId = res.content.orgId + ""
          this.getjgList()
          let ids = res.content.taskId.split(",").map(Number)
          this.checkList = ids
          this.getTaskInform(ids)
          this.showadd = true
        } else {
          this.$message({
            message: "数据项加载异常",
            type: "error",
          })
          this.showadd = false
        }
        this.$nextTick(() => {
          this.mapInit("mapDome")
        })
      } else {
        this.editDisable = false
        this.showSaveBtn = true
        this.showadd = true
        this.dialogTitle = "新增"
        this.baseForm = {}
        this.fileList = []
        this.$nextTick(() => {
          this.mapInit("mapDome")
        })
      }
    },

    //获取新增所有数据发请求
    async saveadddata() {
      let url = "/admin/way/info/updateWay"
      if (this.flag == "add") {
        url = "/admin/way/info/insertWay"
      }
      var res = await request({
        url: url,
        method: "POST",
        data: {
          ...this.baseForm,
        },
      })
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + "成功",
          type: "success",
        })
        this.showadd = false
        this.getPageDatas()
      } else {
        this.$message({
          message: this.dialogTitle + "失败：" + res.message,
          type: "error",
        })
      }
    },
    // 新增弹出框重置
    clearadddata(done) {
      this.showadd = false
      this.markerList = []
      this.haveList = []
      this.checkList = []
      this.jwList = []
      this.jgList = []
      done()
    },
    //删除操作
    async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = {}
          data.id = id
          var res = await request({
            url: "/admin/way/info/deleteWay",
            method: "POST",
            data: data,
          })
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            })
            this.showadd = false
            this.getPageDatas()
          } else {
            this.$message({
              message: "删除失败：" + res.message,
              type: "error",
            })
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },

    //初始化地图插件的方法
    mapInit(containerId) {
      this.mapcontainer = new AMap.Map(containerId, {
        resizeEnable: true,
        zoom: 18,
        zooms: [3, 20],
        expandZoomRange: true,
      })
      // this.mapmarker = new AMap.Marker({
      //   // position: [longitude, latitude],
      //   map: this.mapcontainer
      // });
    },
  },
  mounted() {
    this.getPageDatas()
    this.getOrgLevel()
  },
}
</script>

<style lang="less" scoped>
.check {
  border-radius: 4px;
  width: 70%;
  height: 150px;
  border: 1px solid #e8e8e8;
  overflow: auto;
}
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
      font-size: 22px;
    }
    .tabBtn:nth-child(2) {
      color: #ff04ed;
      // font-size: 25px;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
      // font-size: 25px;
    }
    .tabBtn:nth-child(5) {
      color: #e400ff;
      font-size: 22px;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
      // font-size: 25px;
    }
    .active_Btn {
      color: #ff04ed !important;
      // font-size: 25px;
    }
  }
}
</style>